<script setup lang="ts">
import { KsIcon } from "@aschehoug/kloss";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";

const route = useRoute();

const login = useLogin(() => route.path);
</script>

<template>
  <div
    class="flex h-full flex-col items-center justify-center gap-s rounded-md bg-green-10 p-m pb-l text-center"
  >
    <KsIcon
      :icon="faInfoCircle"
      :scale="1.5"
      class="text-green-pop"
    />
    <p class="text-sm text-green-50">
      Dette produktet kan ikke bestilles av privatpersoner (med Vipps).
      <button class="underline" @click="login('feide')">
        Logg inn som bedrift (med Feide)
      </button> for å bestille.
    </p>
  </div>
</template>
